module.exports = __webpack_public_path__ + "img/需求发布.e09f7a04.png";